// Локальные стили новых компонентов расчёта; общая тема сайта не меняется.
const primary = 'var(--joy-palette-text-primary)';
const secondary = 'var(--joy-palette-text-secondary)';
const divider = 'var(--joy-palette-divider)';
export const noticeSx = {
    bgcolor: 'var(--joy-palette-background-level2)', color: primary,
    border: `1px solid ${divider}`, borderRadius: '12px',
    fontSize: 13, lineHeight: 1.6, alignItems: 'flex-start',
    '&.MuiAlert-colorWarning': { borderLeft: '3px solid #f5b942' },
    '&.MuiAlert-colorDanger': { borderLeft: '3px solid #ef7777' },
    '&.MuiAlert-colorSuccess': { borderLeft: '3px solid #43d39e' },
};
export const sectionSx = {
    p: { xs: 1.5, sm: 2 }, bgcolor: 'var(--joy-palette-background-level1)',
    border: `1px solid ${divider}`, borderRadius: 'var(--joy-radius-xl)',
    '& > summary': { cursor: 'pointer', fontSize: 14, fontWeight: 700,
        color: primary, '&:focus-visible': { outline: '2px solid #b24aef', outlineOffset: 4 } },
    '&[open] > summary': { mb: 1.5 },
};
export const payrollSurfaceSx = {
    color: primary,
    '& .MuiTypography-root': { color: primary },
    '& .MuiTypography-body-sm': { color: secondary, fontSize: 12.5, lineHeight: 1.6 },
    '& .MuiAlert-root': noticeSx,
    '& .MuiCheckbox-label': { color: primary, fontSize: 13 },
    '& .MuiButton-root': { borderRadius: '10px', fontWeight: 700, minHeight: 38 },
    '& .MuiButton-variantOutlined': { color: primary, borderColor: divider },
    '& .MuiButton-variantPlain': { color: '#c56ffa' },
    '& .MuiButton-root.Mui-disabled': { color: secondary, opacity: 0.5 },
    '& details': sectionSx,
};
export const dialogSx = {
    ...payrollSurfaceSx,
    bgcolor: 'var(--joy-palette-background-level1)',
    border: `1px solid ${divider}`, borderRadius: 'var(--joy-radius-xl)',
    boxShadow: '0 24px 80px rgba(0,0,0,0.45)',
    width: { xs: 'calc(100vw - 24px)', sm: 'min(960px, calc(100vw - 48px))' },
    maxWidth: 'none', minWidth: 0, maxHeight: 'calc(100dvh - 32px)',
    overflowY: 'auto', p: { xs: 2, sm: 3 },
    '& .MuiModalClose-root': { color: secondary, borderRadius: '10px' },
};
export const tableSx = {
    minWidth: 640, color: primary, fontSize: 12.5,
    '--TableCell-headBackground': 'var(--joy-palette-background-level2)',
    '--TableCell-borderColor': divider,
    '& thead th': { color: secondary, fontSize: 11, fontWeight: 700 },
    '& tbody td': { color: primary, py: 1.5 },
    '& tbody tr:nth-of-type(even)': { bgcolor: 'rgba(162,38,226,0.035)' },
    '& tbody tr:hover': { bgcolor: 'var(--joy-palette-background-level2)' },
    '& th:nth-of-type(n+3), & td:nth-of-type(n+3)': {
        textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums',
    },
};